module.exports = "data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blank.gif
// module id = 1055
// module chunks = 114